import {
  GET_REPORT_SUBMITTED_TIME,
  GET_REPORT_SUBMITTED_TIME_SUCCESS,
  GET_REPORT_SUBMITTED_TIME_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  reportSubmittedTimeList: [],
  count: 0,
  error: null,
}

const reportSubmittedTime = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_REPORT_SUBMITTED_TIME:
      return { ...state }
    case GET_REPORT_SUBMITTED_TIME_SUCCESS:
      return {
        ...state,
        reportSubmittedTimeList: action.payload?.datas || [],
        count: action.payload?.count || 0,
      }
    case GET_REPORT_SUBMITTED_TIME_ERROR:
      return { ...state, error: action.payload }
    default:
      return state
  }
}

export default reportSubmittedTime
